import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUser } from "../api/auth";
import { profileApi, markPhoneProvided } from "../api/profile";
import { phoneError } from "../lib/phone";
import { COUNTRY_CODES } from "../data/countryDialCodes";
import { readNext } from "../lib/nextUrl";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/auth.css";

// Where a signed-in user without a WhatsApp number supplies one. Reached two
// ways, both via ProfileGuard: a Google sign-up (Google returns no phone), and
// anyone who registered before the number was required.
//
// Deliberately offers no way past it. A "later" link would be clicked forever
// and the list would never fill, which is the whole point of asking.
const CompleteProfilePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = getUser();

  const [countryCode, setCountryCode] = useState("+91");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");

    const msg = phoneError(countryCode, phoneNumber);
    if (msg) { setError(msg); return; }

    setLoading(true);
    try {
      await profileApi.completeProfile({ countryCode, phoneNumber });
      // Clear the flag on the stored user before navigating, or the guard
      // sends us straight back here.
      markPhoneProvided();
      navigate(readNext(location.search), { replace: true });
    } catch (err) {
      setError(err.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", background: "#f2efe8" }}>
      <Navbar />
      <div className="auth-page">
        <div className="auth-card">
          <h1 className="auth-heading">One last thing</h1>
          <p className="auth-sub">
            {user?.name ? `Thanks, ${String(user.name).split(" ")[0]}. ` : ""}
            Add your WhatsApp number so we can send you new CAD automation
            resources.
          </p>

          {error && <div className="auth-error">{error}</div>}

          <form onSubmit={submit}>
            <div className="auth-field">
              <label>WhatsApp number</label>
              <div style={{ display: "flex", gap: 8 }}>
                <select
                  value={countryCode}
                  onChange={(e) => setCountryCode(e.target.value)}
                  style={{ flex: "0 0 96px" }}
                  aria-label="Country code"
                >
                  {COUNTRY_CODES.map((c) => (
                    <option key={c.id} value={c.dial}>
                      {c.dial} {c.id}
                    </option>
                  ))}
                </select>
                <input
                  type="tel"
                  inputMode="numeric"
                  autoComplete="tel-national"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  placeholder="9876543210"
                  style={{ flex: "1 1 auto", minWidth: 0 }}
                  autoFocus
                />
              </div>
              <p className="auth-hint">
                We send new CAD automation resources here. Reply STOP any time.
              </p>
            </div>

            <button className="auth-btn" type="submit" disabled={loading}>
              {loading ? "Saving…" : "Continue"}
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CompleteProfilePage;
